module.exports = __webpack_public_path__ + "c6ff47ab5d9af66bd1bfd4c53f468529.png";